import { useState } from 'react';

import { Header, Tabs, Group, Button, Divider, Menu } from '@mantine/core';
import { GetDeviceStatus } from '../logic/GetDeviceStatus';
import { Link } from 'react-router-dom';
import {TomSWLogo} from "./TomSWLogo";
import { IconHome2, IconUser, IconCodeCircle, IconLogin, IconLayoutDashboard, IconSignature, IconUserCircle } from '@tabler/icons';
import {HeaderTabsModel} from "../models/components/HeaderTabsModel";
import {SystemMemoryProps} from "../models/SystemMemoryProps";

function ProcessTabs(body: HeaderTabsModel) {
    // If the user is logged in
    let rightSide;
    if (body.memory[0].isSignedIn) {
        rightSide = (
            <><Link style={{textDecoration: 'none'}} to="/account/dashboard"><Button color="indigo"><IconLayoutDashboard size={22}/>   Dashboard</Button></Link>
            <Link style={{textDecoration: 'none'}} to="/account"><Button color="violet"><IconUserCircle size={22}/></Button></Link></>
        )
    }
    else {
        rightSide = (
            <><Link style={{textDecoration: 'none'}} to="/login"><Button color="violet">Login</Button></Link>
                <Link style={{textDecoration: 'none'}} to="/register"><Button color="indigo">Register</Button></Link></>
        )
    }

    return (
        <><Tabs color="indigo" variant="pills" defaultValue={body.highlight}>
            <Tabs.List position="center">
                <Link style={{textDecoration: 'none'}} to="/"><Tabs.Tab value="home">Home</Tabs.Tab></Link>
                <Link style={{textDecoration: 'none'}} to="/about-me"><Tabs.Tab value="about">About Me</Tabs.Tab></Link>
                <Link style={{textDecoration: 'none'}} to="/portfolio"><Tabs.Tab value="portfolio">Portfolio</Tabs.Tab></Link>
            </Tabs.List>
        </Tabs>
        <Group>
            {rightSide}
        </Group></>
    );
}

function HeaderTabs({memory}: SystemMemoryProps) {
    const [opened, setOpened] = useState(false);
    const title = opened ? 'Close navigation' : 'Open navigation';
    if (GetDeviceStatus()) {
        // If the user is logged in
        let rightSide;
        if (memory[0].isSignedIn) {
            rightSide = (
                <><Menu.Label>Information</Menu.Label>
                <Link style={{textDecoration: 'none'}} to="/account/dashboard"><Menu.Item icon={<IconLayoutDashboard size={14}/>}>Dashboard</Menu.Item></Link>
                    <Link style={{textDecoration: 'none'}} to="/account"><Menu.Item icon={<IconUserCircle size={14}/>}>Account</Menu.Item></Link></>
            )
        }
        else {
            rightSide = (
                <><Menu.Label>Authentication</Menu.Label>
                    <Link style={{textDecoration: 'none'}} to="/login"><Menu.Item icon={<IconLogin size={14}/>}>Login</Menu.Item></Link>
                    <Link style={{textDecoration: 'none'}} to="/register"><Menu.Item icon={<IconSignature size={14}/>}>Register</Menu.Item></Link></>
            )
        }

        return (
            <><Menu shadow="md" width={"100vh"}>
                <Menu.Target>
                    <Button variant="subtle" color="indigo">
                        Menu
                    </Button>
                </Menu.Target>

                <Menu.Dropdown>
                    <Menu.Label>Navigation Menu</Menu.Label>
                    <Link style={{textDecoration: 'none'}} to='/'><Menu.Item icon={<IconHome2 size={14}/>}>Home</Menu.Item></Link>
                    <Link style={{textDecoration: 'none'}} to='/about-me'><Menu.Item icon={<IconUser size={14}/>}>About Me</Menu.Item></Link>
                    <Link style={{textDecoration: 'none'}} to='/portfolio'><Menu.Item icon={<IconCodeCircle size={14}/>}>Portfolio</Menu.Item></Link>
                    <Menu.Divider/>
                    {rightSide}
                </Menu.Dropdown>
            </Menu></>
        );
    }
    else {
        const model: HeaderTabsModel = {
            memory: memory,
            highlight: ''
        }

        if (window.location.pathname === '/' || window.location.pathname === '/home') {
            model.highlight = 'home';
        }
        else if (window.location.pathname === '/about-me') {
            model.highlight = 'about';
        }
        else if (window.location.pathname === '/portfolio') {
            model.highlight = 'portfolio';
        }

        return ProcessTabs(model);
    }
}

export function NavMenu({memory}: SystemMemoryProps) {
    return (
        <><Header height={60} p="xs">{<Group position="apart"><><TomSWLogo width={50} height={40} /><HeaderTabs memory={memory} /></></Group>}</Header><Divider size="md" /></>
    );
}